export const CHECKOUT_REDIRECT_LOCK_KEY = 'checkout_redirect_lock';
